/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_On_TimeInputs */

const vi_dashboard_driver_on_time = /** @type {(inputs: Dashboard_Driver_On_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đúng SLA`)
};

/**

* @param {Dashboard_Driver_On_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_on_time = /** @type {((inputs?: Dashboard_Driver_On_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_On_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_on_time(inputs)
});